import { commonTranslations } from '../constants';

export const searchTranslations = {
  ...commonTranslations,
  search_hits: 7474,
  search_no_users: 7572,
  search_no_roles: 8052,
  add_user: 5541,
  add_role: 8037,
  new_role: 5482,
  role_administration: 8038,
  page_of: 8454,

  technical_user_delete_title: 8767,
  technical_user_delete_description: 8768,
  technical_user_delete_confirmation: 8769,

  // query filters
  search_on: 8143,
  name: 5244,
  email: 5245,
  user_id: 5243,
  role_id: 4897,
  alternative_id: 4898,
  alternative_id_name: 8138,

  // filter labels
  filters_title: 7556,
  filters_predefined_filters: 7553,
  filters_exclude: 7638,
  filters_include: 7639,
  clear_all_filters: 8139,

  select_all: 8420,
  clear_all: 8421,

  // predefined filters
  inactive_users: 8142,
  technical_users: 8760,
  users_administrated_by_me: 8159,
  without_email: 8141,
  without_alternative_id: 8140,

  // filter names
  role: 5247,
  responsible_for_unit: 8928,
  user_type: 7620,
  main_user_group: 5250,
  current_user_group: 5249,
  extended_access: 7701,
  restricted_access: 5268,
  access_to_operation: 5285,
  access_to_screen: 5286,
  access_to_administrate_user_group: 5276,
  code: 5483,
  my_unit: 7714,
  my_location: 7715,
  disabled_date: 8397,
  latest_activity: 8585,
  visible_for_fields: 8738,
  created_date: 9168,

  // filter labels
  application_or_case_type: 7699,
  case_type: 4015,
  unit: 5262,
  location: 8803,
  operation: 5258,
  screen: 5255,
  exclude_inherited_from_role: 8158,
  option_list: 4013,
  default_values: 4012,
  default_value: 4016,
  field: 4014,
  experience_transfer_alerts: 8842,
  case_types: 9003,

  // filter menus
  clear_filter: 7662,
  filter_menu_option_include: 7698,
  filter_menu_option_exclude: 7693,
  filter_menu_option_include_sub: 7696,
  filter_menu_option_exclude_sub: 7691,
  filter_menu_option_include_parent: 8180,
  filter_menu_option_exclude_parent: 8178,

  // filter options
  search: 7345,
  no_options_found: 7644,
  done: 7338,

  // filter summary
  show_details: 7640,
  hide_details: 7641,
  filter_summary_exclude: 8034,
  filter_summary_exclude_sub: 8033,
  filter_summary_exclude_parent: 8179,

  // filter validation
  number_validator_error: 7725,

  // excel
  excel_export_item_text: 8149,
  user_excel_started: 8151,
  user_excel_success: 8150,
  role_excel_started: 8584,
  role_excel_success: 8583,

  no_access_has_been_granted: 8156,
  no_access_to_role_administration: 8296,
  no_access_to_user_administration: 8297,

  filters_date_range_to: 7600,
  filters_date_range_from: 7567,
  filters_date_range_date_interval: 3707,
  filters_not_specified_title: 7832,
  filters_not_specified_subtitle: 7831,

  // external user handling
  invite_new_user: 8643,
  external_user_handling_redirect_info: 8644,

  // default role
  mark_as_default_role_success: 8655,
  mark_as_default_role_failure: 8656,
  remove_default_role_success: 8658,
  remove_default_role_failure: 8657,
  set_as_default_role: 8659,
  remove_default_role: 8660,
  default: 8663,

  technical_user: 8790,
  recover_mfa: 9320
};

export type SearchTranslation = {
  readonly [T in keyof typeof searchTranslations]: string
};

export enum queryFilters {
  name = 'search_in_name',
  email = 'search_in_email',
  id = 'search_in_user_id',
  alternativeId = 'search_in_alternative_id',
  alternativeName = 'search_in_alternative_id_name'
}

export const extraInfoPrefix = 'extraInfo';
